import { authApiUrl, authApiVersion } from "../config";

export default function useApiHelper(
  config = { apiUrl: undefined, headers: {}, options: {} }
) {
  const baseUrl = config.apiUrl || `${authApiUrl}/${authApiVersion}`;

  const _getReqOpts = async () => {
    const reqOpts: RequestInit = {
      headers: {
        "Content-Type": "application/json",
        ...config.headers,
      },
      credentials: "include",
      ...config.options,
    };

    return reqOpts;
  };

  async function _handleResponse<T>(response: Response): Promise<T> {
    console.log("Response status:", response.status);

    try {
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType?.includes("application/json")) {
          return response.json();
        } else {
          return response as unknown as T;
        }
      } else {
        const errorData = await response.json().catch(() => null);

        if (errorData && errorData.message) {
          throw { status: response.status, ...errorData };
        } else {
          throw response;
        }
      }
    } catch (error: any) {
      console.error("Error:", error.message);
      throw error;
    }
  }

  async function get<T>(path: string) {
    let rawRes = await fetch(`${baseUrl}${path}`, {
      ...(await _getReqOpts()),
      method: "GET",
    });

    return await _handleResponse<T>(rawRes);
  }

  async function post<T, U>(path: string, body: T) {
    let rawRes = await fetch(`${baseUrl}${path}`, {
      ...(await _getReqOpts()),
      body: JSON.stringify(body),
      method: "POST",
    });

    let res = await _handleResponse<U>(rawRes);

    return res;
  }

  return {
    get,
    post,
  };
}
